export default "__VITE_ASSET___CIEn6pF__"